import Club from "./SVG/club.svg?react";

const ClubIcon = () => {
  return <Club />;
};

export default ClubIcon;
